import { Graphics, Text } from 'pixi.js';
import { Scene } from '../engine/scene';
import { getContext } from '../engine/context';
import { loadAllAssets } from '../engine/assets';
import { GAME_HEIGHT, GAME_WIDTH } from '../config/tuning';

export class PreloadScene extends Scene {
  private bar!: Graphics;
  private barBg!: Graphics;
  private labelText!: Text;

  async onEnter(): Promise<void> {
    this.drawProgressUi();
    const ctx = getContext();
    await loadAllAssets(ctx.audio, (pct) => this.updateProgress(pct));
    ctx.sceneManager.start('MenuScene');
  }

  private drawProgressUi(): void {
    const cx = GAME_WIDTH / 2;
    const cy = GAME_HEIGHT / 2;
    const w = 600;
    const h = 30;

    const title = new Text({
      text: 'SPLIFFO',
      style: {
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: 96,
        fill: 0xffd23f,
        stroke: { color: 0x1a0d22, width: 6 },
      },
    });
    title.anchor.set(0.5);
    title.position.set(cx, cy - 80);
    this.addChild(title);

    this.barBg = new Graphics()
      .roundRect(cx - w / 2, cy - h / 2, w, h, 12)
      .fill({ color: 0x1a1726, alpha: 0.8 })
      .stroke({ color: 0x5fdbcf, width: 3 });
    this.addChild(this.barBg);

    this.bar = new Graphics();
    this.addChild(this.bar);

    this.labelText = new Text({
      text: 'Loading…',
      style: { fontFamily: 'Inter, sans-serif', fontSize: 20, fill: 0x5fdbcf },
    });
    this.labelText.anchor.set(0.5);
    this.labelText.position.set(cx, cy + 50);
    this.addChild(this.labelText);
  }

  private updateProgress(value: number): void {
    const cx = GAME_WIDTH / 2;
    const cy = GAME_HEIGHT / 2;
    const w = 600;
    const h = 30;
    this.bar.clear();
    this.bar
      .roundRect(cx - w / 2 + 4, cy - h / 2 + 4, Math.max(0, (w - 8) * value), h - 8, 8)
      .fill({ color: 0x5fdbcf });
    this.labelText.text = `Loading… ${Math.round(value * 100)}%`;
  }
}

